"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendAnalyticsEvent = void 0;
var analyticsInstance_1 = require("./analyticsInstance");
var deviceUtils_1 = require("./utils/deviceUtils");
var localeUtils_1 = require("./utils/localeUtils");
var cookieUtils_1 = require("./utils/cookieUtils");
var prefixFeatureFlags_1 = require("./utils/prefixFeatureFlags");
var trackingUtils_1 = require("./utils/trackingUtils");
function sendAnalyticsEvent(name, event, options) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var page_url, analytics, instance_properties, session_id, storeProperties, _h, featureFlags, traits;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    page_url = location.pathname;
                    return [4 /*yield*/, (0, analyticsInstance_1.getAnalyticsInstance)()];
                case 1:
                    analytics = _j.sent();
                    return [4 /*yield*/, (0, analyticsInstance_1.getInstanceProperties)()];
                case 2:
                    instance_properties = _j.sent();
                    session_id = (0, trackingUtils_1.defineSessionId)();
                    storeProperties = (0, localeUtils_1.getStoreProperties)();
                    _h = (_b = (_a = options.segment) === null || _a === void 0 ? void 0 : _a.traits) !== null && _b !== void 0 ? _b : {}, featureFlags = _h.featureFlags, traits = __rest(_h, ["featureFlags"]);
                    return [4 /*yield*/, (0, trackingUtils_1.defineAnonymousId)()];
                case 3:
                    _j.sent();
                    return [4 /*yield*/, analytics.track(name, __assign(__assign({ app_name: (_c = instance_properties.app) === null || _c === void 0 ? void 0 : _c.name, 
                            // TODO: remove once B2B reports don't rely on `page_url` without passing them explicitly
                            page_url: page_url }, storeProperties), event), __assign(__assign({}, options.segment), { integrations: __assign({ Amplitude: {
                                    session_id: session_id,
                                } }, (_d = options.segment) === null || _d === void 0 ? void 0 : _d.integrations), device: {
                                type: (0, deviceUtils_1.getDevicePlatform)(), // since web doesn't automatically add this
                            }, traits: __assign(__assign(__assign(__assign(__assign({}, (0, deviceUtils_1.getOSProperties)()), (0, deviceUtils_1.getDeviceProperties)()), (0, cookieUtils_1.getGeoProperties)()), traits), (0, prefixFeatureFlags_1.prefixFeatureFlags)(featureFlags !== null && featureFlags !== void 0 ? featureFlags : {})), context: __assign(__assign({}, (_e = options.segment) === null || _e === void 0 ? void 0 : _e.context), { session_id: session_id, app: __assign(__assign({}, (_g = (_f = options.segment) === null || _f === void 0 ? void 0 : _f.context) === null || _g === void 0 ? void 0 : _g.app), instance_properties.app) }) }))];
                case 4:
                    _j.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.sendAnalyticsEvent = sendAnalyticsEvent;
//# sourceMappingURL=sendAnalyticsEvent.js.map